import { render, staticRenderFns } from "./teacherPlan.vue?vue&type=template&id=50792b64"
import script from "./teacherPlan.vue?vue&type=script&lang=js"
export * from "./teacherPlan.vue?vue&type=script&lang=js"
import style0 from "./teacherPlan.vue?vue&type=style&index=0&id=50792b64&prod&lang=less"


/* normalize component */
import normalizer from "!../../../.yarn/__virtual__/vue-loader-virtual-45869d479f/4/.yarn/berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports